var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"headd"},[_c('div',{staticClass:"headerimg"}),_c('div',{staticClass:"search"}),_c('div',{staticClass:"caidan",on:{"click":_vm.mNav}})])}
var staticRenderFns = []

export { render, staticRenderFns }